<template>
  <layout-loading />
</template>

<script>
import Authenticated from "@/mixins/Authenticated";

export default {
  name: "VerifyEmail",
  mixins: [Authenticated],
  props: {
    code: {
      required: true,
      type: String,
    },
    id: {
      required: true,
      type: String,
    },
  },
  async mounted() {
    try {
      await this.$store.dispatch("account/verifyEmail", {
        id: this.id,
        code: this.code,
        params: this.$route.query,
      });
      this.$store.commit("addNotification", {
        title: this.$t("store.account.notifications.verify_email.title"),
        variant: "success",
        content: this.$t("store.account.notifications.verify_email.success_content"),
      });
    } catch {
      this.$store.commit("addNotification", {
        title: this.$t("store.account.notifications.verify_email.title"),
        variant: "danger",
        content: this.$t("store.account.notifications.verify_email.error_content"),
      });
    } finally {
      if (!this.$store.state.user.has_completed_registration) {
        this.$router.replace("/register/2");
      } else {
        this.$router.replace("/profile/account");
      }
    }
  },
};
</script>

<style lang="scss"></style>
